<template>
  <b-form-group
    label="Fuar Web Sitesi"
    label-for="fair_url"
  >
    <validation-provider
      #default="{ errors }"
      name="Fuar Web Sitesi"
      rules="required|url"
    >
      <b-form-input
        id="fair_url"
        v-model="dataItem.fair_url"
        placeholder="https://www.example.com"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Url',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['fairs/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
